
       function sku(resList) {
        console.log("resList====",resList)
 var arr1 = []
 var arr2 = []
 var arr3 = []

 for (var i = 0; i < resList.length; i++) {
     var str = resList[i].valueName //取出所有的规格值
     var strArr = str.split(",")//并转换成数组
     if (strArr.length == 1) {
         arr1.push(strArr[0])
         arr1 = [...new Set(arr1)]
     }
     if (strArr.length == 2) {
         arr1.push(strArr[0])
         arr1 = [...new Set(arr1)]
     
         arr2.push(strArr[1])
         arr2 = [...new Set(arr2)]
     }
     if (strArr.length == 3) {
         arr1.push(strArr[0])
         arr1 = [...new Set(arr1)]
     
         arr2.push(strArr[1])
         arr2 = [...new Set(arr2)]
     
         arr3.push(strArr[2])
         arr3 = [...new Set(arr3)]
     }
    //  console.log(strArr)
 }
 console.log(arr1)
 console.log(arr2)
 console.log(arr3)

 var obj = []
 var price = 0

 for (var i = 0; i < arr1.length; i++) {
     var valueName = arr1[i];
                     
     if (arr2.length <= 0) {
         for(var o = 0; o < resList.length ;o++){
             if(arr1[i] == resList[o].valueName){
                 price = resList[o].price
             }
                                     
         }
         obj.push({
            spec_value_name: valueName,
             price: price
         })
     } else {
         let arr2Num = []
         for (var j = 0; j < arr2.length; j++) {
             if (arr3 .length <= 0 ) {
                 for(var o = 0; o < resList.length ;o++){
                     if(arr1[i] +','+ arr2[j] == resList[o].valueName){
                         price = resList[o].price
                     }
                 }
                 arr2Num.push({
                    spec_value_name: arr2[j],
                     price: price
                 })
             } else {
                 let arr3Num = []
             
                 for (var k = 0; k < arr3.length; k++) {
                     for(var o = 0; o < resList.length ;o++){
                         if(arr1[i] +','+ arr2[j]+','+ arr3[k] == resList[o].valueName){
                             price = resList[o].price
                         }
                     }
                     arr3Num.push({ 
                        spec_value_name: arr3[k],
                         price: price
                     })
                 }
                 arr2Num.push({
                    spec_value_name: arr2[j],
                     children: arr3Num
                 
                 })
             }

         }
         obj.push({
            spec_value_name: valueName,
             children: arr2Num,
         })
     }
    //  obj.push({
    //     spec_value_name: valueName,
    //      children: arr2Num,
    //  })
 }
 console.log(obj);
  return obj
 
}
export default { 
sku
}